/**
* rcs-channel.util.ts
*
* Frontend mirror of `isRCSConversational` in `@app/trendmulti-core`. The two must stay
* in step: the backend refuses the send, the frontend keeps the channel out of the
* picker and explains why before the agent types.
*/
import { ChannelTypeEnum } from '../models/enum/channel.type';

/** The only fields of a channel the predicate derives from. */
export type RCSChannelLike = { type?: ChannelTypeEnum | string; metadata?: { conversational?: boolean } };

/**
 * Is this channel an RCS account provisioned as conversational?
 *
 * The provider exposes two send routes and which one an account may use is a
 * property of the account, not of the calling screen:
 *
 * - `true`  → conversational account: usable in attendance AND in campaigns.
 * - `false` → campaign-only account: usable in campaigns only.
 *
 * The check is deliberately `=== true`: a channel of another type, one with no
 * metadata, and one whose flag was never set are all non-conversational.
 */
export function isRCSConversational(channel?: RCSChannelLike | null): boolean {
  return channel?.type === ChannelTypeEnum.RCS_API && channel?.metadata?.conversational === true;
}
